import React, { useState, useEffect, useRef } from 'react';
import './Studies.css';

const stories = {
  'The Tortoise and the Hare': `
Once upon a time, a hare was boasting about how fast he could run. 
Tired of hearing him boast, the tortoise challenged him to a race. 
All the animals in the forest gathered to watch.
The hare ran down the road for a while and then stopped to rest. 
He looked back at the tortoise and cried out, "How do you expect to win this race when you are walking along at your slow, slow pace?"
The hare stretched himself out alongside the road and fell asleep, thinking, "There is plenty of time to relax."
The tortoise walked and walked. 
He never, ever stopped until he came to the finish line.
The animals who were watching cheered so loudly for the tortoise that they woke up the hare. 
The hare stretched, yawned, and began to run again, but it was too late. The tortoise had already crossed the finish line.
`,
  'The Lion and the Mouse': `
One day a Lion lay asleep in the forest, his great head resting on his paws. 
A little Mouse came upon him unexpectedly, and in her fright and haste to get away, ran across the Lion's nose. 
Roused from his nap, the Lion laid his huge paw angrily on the tiny creature to kill her.
The poor Mouse begged him to spare her life. "Please let me go and some day I will surely repay you."
The Lion was much amused to think that a Mouse could ever help him. But he was generous and finally let the Mouse go.
Some days later, while stalking his prey in the forest, the Lion was caught in the toils of a hunter's net. 
Unable to free himself, he filled the forest with his angry roaring. 
The Mouse knew the voice and quickly found the Lion struggling in the net. 
Running to one of the great ropes that bound him, she gnawed it until it parted, and soon the Lion was free.
"You laughed when I said I would repay you," said the Mouse. "Now you see that even a Mouse can help a Lion."
`
};

const Studies = () => {
  const [selectedStory, setSelectedStory] = useState('');
  const [storyWords, setStoryWords] = useState([]);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState(null);
  const [speed, setSpeed] = useState(1);
  const synth = useRef(window.speechSynthesis);
  const utterance = useRef(null);

  const appRef = useRef(null);

  useEffect(() => {
    const voicesList = synth.current.getVoices();
    setVoices(voicesList);
    if (voicesList.length > 0) {
      setSelectedVoice(voicesList[0].name);
    }
  }, []);

  const handleStoryChange = (event) => {
    const storyTitle = event.target.value;
    setSelectedStory(storyTitle);
    setStoryWords(stories[storyTitle].trim().split(/\s+/));
    setCurrentWordIndex(0);
  };

  const handleVoiceChange = (event) => {
    setSelectedVoice(event.target.value);
  };

  const handleSpeedChange = (event) => {
    setSpeed(parseFloat(event.target.value));
  };

  const handleReadStory = () => {
    if (utterance.current) {
      synth.current.cancel();
    }
    setCurrentWordIndex(0);
    utterance.current = new SpeechSynthesisUtterance(storyWords.join(' '));
    utterance.current.voice = synth.current.getVoices().find(voice => voice.name === selectedVoice);
    utterance.current.rate = speed;
    utterance.current.onboundary = (event) => {
      if (event.name === 'word') {
        setCurrentWordIndex(event.charIndex);
      }
    };
    synth.current.speak(utterance.current);
  };

  const enterFullScreen = () => { if (appRef.current.requestFullscreen) { appRef.current.requestFullscreen(); } else if (appRef.current.webkitRequestFullscreen) { /* Safari */ appRef.current.webkitRequestFullscreen(); } else if (appRef.current.msRequestFullscreen) { /* IE11 */ appRef.current.msRequestFullscreen(); } }; const exitFullScreen = () => { if (document.exitFullscreen) { document.exitFullscreen(); } else if (document.webkitExitFullscreen) { /* Safari */ document.webkitExitFullscreen(); } else if (document.msExitFullscreen) { /* IE11 */ document.msExitFullscreen(); }

};



  return (
    <div className="story-reader">
      <h1>Kids' Stories</h1>
      <div className="story-selector">
        <label>Select a story: </label>
        <select value={selectedStory} onChange={handleStoryChange}>
          <option value="">--Choose a story--</option>
          {Object.keys(stories).map((title, index) => (
            <option key={index} value={title}>{title}</option>
          ))}
        </select>
      </div>
      {selectedStory && (
        <>
          <div className="voice-selector">
            <label>Select Voice: </label>
            <select value={selectedVoice} onChange={handleVoiceChange}>
              {voices.map((voice, index) => (
                <option key={index} value={voice.name}>{voice.name}</option>
              ))}
            </select>
          </div>
          <div className="speed-selector">
            <label>Speed: </label>
            <input
              type="range"
              min="0.5"
              max="2"
              step="0.1"
              value={speed}
              onChange={handleSpeedChange}
            />
          </div>
          
           <div className='story-reader' ref={appRef}> 
           <button onClick={handleReadStory}>Read Story</button>
           <button onClick={enterFullScreen} className="fullscreen-button">Enter Full Screen</button> 
          <button onClick={exitFullScreen} className="fullscreen-button">Exit Full Screen</button> 
          
          <div className="story-display">
            <h2>{selectedStory}</h2>
             <pre>
              {storyWords.map((word, index) => (
                <span
                  key={index}
                  className={index === currentWordIndex ? 'highlight1' : ''}
                >
                  {word}{' '}
                </span>
              ))}
            </pre> 
          </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Studies;
